export default __webpack_public_path__ + "static/media/Pietermaritzburg_Central.1e9060db.jpg";